import React from 'react';
import { object, string } from 'prop-types';

import CaseLabel from 'containers/CaseCave/CaseDetails/CaseLabels/CaseLabel';
import { DEFAULT_COLORS } from 'constants/colors';

const IndicatorPill = ({ title, color, fontColor, fontSize, width, height, style }) => (
    <CaseLabel
        title={title}
        color={color}
        fontColor={fontColor}
        fontSize={fontSize}
        style={{
            fontWeight: '500',
            fontFamily: 'Roboto',
            padding: '6px 12px',
            borderRadius: '50px',
            whiteSpace: 'nowrap',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            width,
            height,
            ...style,
        }}
    />
);

IndicatorPill.propTypes = {
    title: string.isRequired,
    color: string,
    fontColor: string,
    fontSize: string,
    width: string,
    height: string,
    style: object,
};

IndicatorPill.defaultProps = {
    color: DEFAULT_COLORS.ORANGE,
    fontColor: DEFAULT_COLORS.WHITE,
    fontSize: '14px',
    width: '189px',
    height: '26px',
    style: {},
};

export default IndicatorPill;
